import { UTSLocale } from "@smile2impress/attraction-constants";

import spain from "./spain";
import france from "./france";
import italy from "./italy";
import portugal from "./portugal";
import uk from "./uk";
import ukraine from "./ukraine";
import us from "./us";
import de from "./de";
import se from "./se";
import nl from "./nl";

export default (locale: UTSLocale) => {
    switch (locale) {
        case UTSLocale.SPAIN_ES:
            return spain;
        case UTSLocale.FRANCE_FR:
            return france;
        case UTSLocale.ITALY_IT:
            return italy;
        case UTSLocale.PORTUGAL_PT:
            return portugal;
        case UTSLocale.GB_EN:
            return uk;
        case UTSLocale.UKRAINE_UK:
            return ukraine;
        case UTSLocale.US_EN:
            return us;
        case UTSLocale.GERMANY_DE:
            return de;
        case UTSLocale.SWEDEN_SE:
            return se;
        case UTSLocale.NL_NL:
            return nl;
        default:
            return uk;
    }
};
